<!-- Base.Dropzone.vue (client-lms) -->
<template>
  <div
    class="lms_dropzone"
    :class="{ active: isDragging }"
    @click="onClick"
    @dragover.prevent="isDragging = true"
    @dragleave="isDragging = false"
    @drop.prevent="onDrop"
  >
    <input ref="inputRef" type="file" :accept="accept" :multiple="multiple" hidden @change="onSelect" />
    <slot>
      <i class="icon_file_up" style="width: 24px; height: 24px; background-color: var(--lms-primary-300) !important; "></i>
      <p class="lms_dropzone_text">{{ message }}</p>
    </slot>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

const props = defineProps({
  accept: { type: String, default: "" },
  multiple: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
  message: { type: String, default: "업로드 버튼을 클릭하거나 파일을 끌어서 첨부할\n파일을 업로드해 주세요." },
});

const emit = defineEmits<{
  (e: "files", files: FileList): void;
}>();

const inputRef = ref<HTMLInputElement>();
const isDragging = ref(false);

const onClick = () => {
  if (props.disabled) return;
  inputRef.value?.click();
};

const onSelect = (e: Event) => {
  const input = e.target as HTMLInputElement;
  if (input.files?.length) emit("files", input.files);
  input.value = "";
};

const onDrop = (e: DragEvent) => {
  isDragging.value = false;
  if (props.disabled) return;
  if (e.dataTransfer?.files?.length) emit("files", e.dataTransfer.files);
};

defineExpose({ trigger: () => inputRef.value?.click() });
</script>
